<script setup lang="ts">
import type { BannerTypeFragment } from '#graphql-operations'

defineProps<{
  banners: BannerTypeFragment[]
}>()
</script>

<template>
  <div
    v-if="banners?.length"
    class="catalog-banners"
    :style="`--columns: ${banners.length};`"
  >
    <ul
      class="catalog-banners__list"
    >
      <li
        v-for="banner in banners"
        :key="banner"
        class="catalog-banners__item"
      >
        <StrapiBanner
          :banner="banner"
          class="catalog-banners__banner"
          :lazy="false"
          :banner-count="banners?.length"
        />
      </li>
    </ul>
  </div>
</template>

<style>
  @import url("~layers/components/Catalog/Banners.css");
</style>
